import { ELanguage, II18nInitOptions } from 'odc-shared/i18n';

import en from './en.json';
import zh from './zh.json';

export const resources: II18nInitOptions['resources'] = {
  [ELanguage.En]: en,
  [ELanguage.Zh]: zh,
};
